/* eslint-disable @typescript-eslint/camelcase */
import { FormErrors } from 'redux-form';
// @ts-ignore
import MESSAGES from 'constants/messages';
// @ts-ignore
import isNumeric from 'validator/lib/isNumeric';

interface Errors {
  password?: string;
  confirm_password?: string;
}

export default ({ password, confirm_password }: Errors): FormErrors<Errors> => {
  const errors: FormErrors<Errors> = {};

  if (!password) {
    errors.password = MESSAGES.RESET_PASSWORD.PASSWORD.REQUIRED;
  }

  if (password && isNumeric(password)) {
    errors.password = MESSAGES.RESET_PASSWORD.PASSWORD.NUMERIC;
  }

  if (password && password.length < 8) {
    errors.password = MESSAGES.RESET_PASSWORD.PASSWORD.MIN_LEN;
  }

  if (!confirm_password) {
    errors.confirm_password = MESSAGES.RESET_PASSWORD.CONFIRM_PASSWORD.REQUIRED;
  }

  if (password && confirm_password && password !== confirm_password) {
    errors.confirm_password = MESSAGES.RESET_PASSWORD.MATCH;
  }

  return errors;
};
